import { apiSlice } from "app/api/apiSlice"

export const FPOApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getEnsuredIttoken: builder.query({
            query: () => `/api/v1/auth/sso/ensuredit/B2C/token`
        }), 
    
    // getCrmInsuranceLeads: builder.query({
    //     query: ({pagination,searchKey,selectedProduct,stateName,districtName,blockName,
    //         statusName}) => `/api/v1/crm/insurance/leads?page=${pagination.page}&per_page=100&q=${searchKey}&product_name=${selectedProduct}&state_name=${stateName}&district_name=${districtName}&block_name=${blockName}&current_status=${statusName}`
    // }), 
    getCrmInsuranceLeads: builder.query({
        query: ({ page,perPage, searchKey, selectedProduct, stateCode, districtCode, blockCode, statusName,statusIncludes }) => {
          let url = `/api/v1/crm/insurance/leads?page=${page}&per_page=${perPage}`;
          if (searchKey) url += `&q=${searchKey}`;
          if (selectedProduct) url += `&product_name=${selectedProduct}`;
          if (stateCode) url += `&state_code=${stateCode}`;
          if (districtCode) url += `&district_code=${districtCode}`;
          if (blockCode) url += `&block_code=${blockCode}`;
          if (statusName) url += `&current_status=${statusName}`;
          if (statusIncludes) url += `&status_includes=${statusIncludes}`;

          return url;
        },
      }),
      getInsuranceAgency: builder.query({
        query: ({pagination,searchKey}) => `/api/v1/onboarding/employees/INS_AGENCY/?q=${searchKey}`
    }),
    getInsuranceAgencyUsers: builder.query({
      query: ({searchKey,stateId,districtId}) => `/api/v1/onboarding/employees/INS_AGENCY_USER/?q=${searchKey}&state_code=${stateId}&district_code=${districtId}`
  }),
  // getAssignDrList: builder.query({
  //   query: ({ pagination, searchKeyStatus,product_name,stateId, districtId }) => `/api/v1/crm/insurance/leads/?page=${pagination.page}&per_page=${pagination.perPage}&q=${searchKeyStatus}&product_name=${product_name}&state_code=${stateId}&district_code=${districtId}`
  // }),
  // getAssignPolicy: builder.query({
  //   query: ({ pagination, searchKeyStatus,status,stateId,districtId }) => `/api/v1/crm/insurance/leads/?page=${pagination.page}&per_page=${pagination.perPage}&q=${searchKeyStatus}&current_status=${status}&state_code=${stateId}&district_code=${districtId}`
  // }),
   getInsuranceLeadsUnassigned: builder.query({
      query: ({ pagination, searchKeyStatus,product_name, }) =>
        `/api/v1/crm/insurance/leads/unassigned?page=${pagination.page}&per_page=10&q=${searchKeyStatus}&product_name=${product_name}` 
       ,
    }),
     uploadInsuranceFarmerDocs: builder.mutation({
      query: (payload) => ({
        url: "api/v1/onboarding/farmer-documents-zip",
        method: "POST",
        body: payload,
      }),
    }),
    
   
      
})
})

export const {  useGetEnsuredIttokenQuery, useGetCrmInsuranceLeadsQuery,useGetInsuranceAgencyQuery,useGetInsuranceAgencyUsersQuery,useGetAssignDrListQuery,
  useGetAssignPolicyQuery,useGetInsuranceLeadsUnassignedQuery,useUploadInsuranceFarmerDocsMutation} = FPOApiSlice 